<template>
  <div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header bg-transparent">

            <div class="row">
              <div class="col-6">
                <h3 class="card-title mb-0"> {{$t('menu.3')}}</h3>

              </div>

              <div class="col-6 mt-2">
                <el-button-group class="pull-right">
                  <el-tooltip :content="$t('yeni')" placement="bottom">
                    <el-button type="success" size="mini" icon="el-icon-plus" circle @click="yeni"></el-button>
                  </el-tooltip>
                </el-button-group>

              </div>
            </div>

          </div>

          <div class="card-body">

            <el-col :span="24">
              <el-table
                :data="veri()"
                style="width: 100%">

                <el-table-column
                  :label="$t('urun.adi')"
                  prop="adi">
                </el-table-column>

                <el-table-column
                  :label="$t('urun.kategori')"
                  prop="kategori">
                </el-table-column>

                <el-table-column
                  :label="$t('urun.uyari')">
                  <template slot-scope="Data">
                    <el-tag type="success">
                      <p>{{Data.row.uyari+' '+Data.row.birim}}</p>
                    </el-tag>
                  </template>
                </el-table-column>


                <el-table-column
                  :label="$t('urun.alis')"
                  prop="alis">
                </el-table-column>

                <el-table-column
                  :label="$t('urun.satis')"
                  prop="satis">
                </el-table-column>


                <el-table-column
                  align="right">
                  <template slot="header" slot-scope="scope">
                    <el-input
                      v-model="search"
                      size="mini"
                      :placeholder="$t('ara')"/>
                  </template>
                  <template slot-scope="scope">
                    <el-tooltip :content="$t('duzenle')" placement="right">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="handleEdit(scope.$index, scope.row)"><i class="i-Brush"></i>
                      </el-button>
                    </el-tooltip>
                    <el-tooltip :content="$t('sil')" placement="right">
                      <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, Data, scope.row)"><i class="i-Folder-Trash"></i>
                      </el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>

            </el-col>
          </div>
        </div>

      </div>

    </div>


    <el-dialog :title="$t('urun.isim')" :visible.sync="modal">

      <el-form :model="UrunForm" status-icon ref="UrunForm" size="mini" label-width="120px">

        <el-form-item
          prop="Kategori_id"
          :label="$t('urun.kategori')"
          :rules="[
          { required: true, message: $t('bos') },
          ]">
          <el-select v-model="UrunForm.Kategori_id">
            <el-option
              v-for="index in Kategori"
              :key="index.id"
              :label="index.adi"
              :value="index.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          prop="adi"
          :label="$t('urun.adi')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('urun.bos') }]">
          <el-input v-model="UrunForm.adi"></el-input>
        </el-form-item>

        <el-form-item
          prop="urunkodu"
          :label="$t('urun.kodu')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('urun.bos') }]">
          <el-input v-model="UrunForm.urunkodu"></el-input>
        </el-form-item>


        <el-form-item
          prop="birim"
          :label="$t('urun.birim')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('urun.bos') }]">
          <el-input v-model="UrunForm.birim"></el-input>
        </el-form-item>

        <el-form-item
          prop="uyari"
          :label="$t('urun.uyari')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('urun.bos') }]">
          <el-input v-model.number="UrunForm.uyari"></el-input>
        </el-form-item>


        <el-form-item
          prop="alis"
          :label="$t('urun.alis')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('urun.bos') }]">
          <el-input v-model.number="UrunForm.alis"></el-input>
        </el-form-item>

        <el-form-item
          prop="satis"
          :label="$t('urun.satis')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('urun.bos') }]">
          <el-input v-model.number="UrunForm.satis"></el-input>
        </el-form-item>


        <el-form-item
          prop="kdv"
          :label="$t('urun.kdv')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('urun.bos') }]">
          <el-input v-model.number="UrunForm.kdv"></el-input>
        </el-form-item>


        <el-form-item
          prop="id"
          autocomplete="off"
          type="hidden">
          <el-input type="hidden" :value="this.UrunForm.id"></el-input>
        </el-form-item>


      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="modal = false, yenimodal = false">{{$t('iptal')}}</el-button>
        <el-button type="primary" @click="onSubmit('UrunForm')">{{$t('kaydet')}}</el-button>

      </span>
    </el-dialog>

  </div>
</template>

<script>


    export default {
        data() {
            return {
                Kategori: [],
                Data: [],
                modal: false,
                search: '',
                UrunForm: {
                    id: '',
                    adi: '',
                    kodu: '',
                    birim: '',
                    uyari: '',
                    alis: '',
                    satis: '',
                    kdv: '',
                    Kategori_id: '',

                },

                yenimodal: false,
                formLabelWidth: '180px',
            }
        },
        methods: {
            veri() {
                if (this.Data != null) {
                    var veri = this.Data.filter(data => !this.search || data.adi.toLowerCase().includes(this.search.toLowerCase()))
                } else if (this.Data == '') {
                    var veri = this.Data;
                }
                return veri
            },
            handleEdit(index, row) {
                console.log(row)
                this.yenimodal = false
                this.UrunForm = row
                this.modal = true
            },
            handleDelete(index, row, rows) {
                row.splice(index, 1);
                console.log(rows)

                this.$store.dispatch("dataver", {
                    method: 'delete',
                    url: '/urun/' + rows.id,
                    data: ''
                }).then(response => {
                    if (response.Status == 'OK') {

                    } else {

                    }
                });


            },
            UrunListele() {
                this.$store.dispatch("dataver", {method: "get", url: "/urun"})
                    .then(response => {
                        console.log(response)
                        if (response.Status == 'OK') {
                            this.Data = response.Data;
                        } else {

                        }
                    });
            },
            KategoriListele() {
                this.$store.dispatch("dataver", {method: "get", url: "/kategori/4"})
                    .then(response => {
                        if (response.Status == 'OK') {
                            this.Kategori = response.Data;
                            this.UrunForm.Kategori_id = response.Data[0].id;
                        } else {

                        }
                    });
            },
            onSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.yenimodal == false && this.UrunForm.id) {

                            this.$store.dispatch("dataver", {
                                method: 'put',
                                url: '/urun/' + this.UrunForm.id,
                                data: this.UrunForm
                            }).then(response => {
                                console.log(response)
                                if (response.Status == 'OK') {
                                    this.UrunListele()
                                    this.modal = false
                                } else {

                                }
                            })

                        }

                        if (this.yenimodal == true) {

                            this.$store.dispatch("dataver", {
                                method: 'post',
                                url: '/urun/',
                                data: this.UrunForm
                            }).then(response => {
                                console.log(response)
                                if (response.Status == 'OK') {
                                    this.UrunListele()
                                    this.modal = false
                                } else {

                                }
                            })

                        }

                    }
                });
            },
            yeni() {
                this.UrunForm = {}
                this.yenimodal = true
                this.modal = true
            },

        },
        created() {
            this.KategoriListele()
            this.UrunListele()

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/urun/index.vue